import { createContext } from 'react';
import StaticAppConfig from './i-classes/staticAppConfig';

export const AppContext = createContext({
    staticAppConfig: {} as StaticAppConfig, SetStaticAppConfig: (value: StaticAppConfig) => {},
    //database
    databaseActionModeQueueRef: {} as any,
    databaseActionModeQueue: [] as string[], SetDatabaseActionModeQueue: (value: string[]) => { },
    databaseActionParamsQueueRef: {} as any,
    databaseActionParamsQueue: [] as any[], SetDatabaseActionParamsQueue: (value: any) => { },
    databaseResultAction: null as any,
    databaseShouldShowWaitScreen: true, SetDatabaseShouldShowWaitScreen: (value: boolean) => { },
});